// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"31":"9e2632bc","111":"080670c2","179":"ee5a69e7","446":"afdbb80e","488":"22b449f6","595":"a7eac1e7","635":"8d4d2c5e","728":"56e56d2d","732":"be222102","814":"dd9d2cf4","868":"d8b0b662","969":"6f49c79a","979":"ff9fb5db"}[chunkId] + ".chunk.js";
};